module.exports = __webpack_public_path__ + "static/img/poster.7257c47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/poster.jpg
// module id = nfnq
// module chunks = 0